export default __webpack_public_path__ + "static/media/rentyBlackIcon.2c942c28.svg";